import { storageClear } from 'app/React/Helpers/StorageHelper'
import { accessoryStorageSet } from "app/React/Helpers/AccessoryStorageHelper";

export function goToConfirmationPage(identifier, res) {
  storageClear(identifier)
  accessoryStorageSet('cart-items', [])
  window.location.href = res.data.accept_url
}
